/*
 * The Firebase project behind accounts: Authentication for sign-in, Firestore
 * for each reader's My Study.
 *
 * Off unless the REACT_APP_FIREBASE_* variables are set (see .env.example),
 * the same as error reporting, and loaded through dynamic imports so that while
 * it is off none of the SDK is downloaded. These values are public by design --
 * they ship inside the client bundle. What keeps one reader out of another's
 * notes is firestore.rules, not secrecy here.
 */

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(
  config.apiKey && config.authDomain && config.projectId && config.appId
);

let services = null;

/**
 * { app, auth, db, authApi, firestoreApi }, or null when accounts are off or
 * the SDK could not be loaded.
 *
 * Firestore keeps its default in-memory cache rather than a persistent one: a
 * reader who signs in on a shared computer should not leave their notes in
 * that browser's storage after signing out.
 */
export function loadFirebase() {
  if (!isFirebaseConfigured) return Promise.resolve(null);

  if (!services) {
    services = Promise.all([
      import("firebase/app"),
      import("firebase/auth"),
      import("firebase/firestore"),
    ])
      .then(([appApi, authApi, firestoreApi]) => {
        const app = appApi.initializeApp(config);
        return {
          app,
          auth: authApi.getAuth(app),
          db: firestoreApi.getFirestore(app),
          authApi,
          firestoreApi,
        };
      })
      .catch((error) => {
        console.warn("Accounts could not be loaded", error);
        return null;
      });
  }

  return services;
}
